import script from "./ConfigCallForm.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ConfigCallForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfigCallForm.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ConfigCallForm.vue?vue&type=script&setup=true&lang=ts"

import "./ConfigCallForm.vue.scss?vue&type=style&index=0&id=266c9311&lang=scss!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ConfigCallForm.vue?vue&type=style&index=0&id=266c9311&lang=scss"

const __exports__ = script;

export default __exports__